import {
  useState,
} from "react";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function ContactUs() {

  const [submitted,
    setSubmitted] =
    useState(false);

  const handleSubmit =
    (e) => {

      e.preventDefault();

      setSubmitted(true);
    };

  return (
    <>
      <SEO
        title="Contact Us - Online Tools Center"
        description="Contact Online Tools Center for support, feedback, suggestions, or business inquiries."
        keywords="contact online tools center, support, feedback"
        url="https://online-tools-center.vercel.app/contact-us"
      />

      <Navbar />

      {/* HERO */}

      <section
        style={{
          background:
            "linear-gradient(135deg,#0f172a,#1e293b)",
          color: "white",
          padding:
            "80px 20px",
        }}
      >

        <div className="container text-center">

          <span className="badge bg-primary p-2 mb-3">
            Contact Support
          </span>

          <h1
            className="fw-bold mb-4"
            style={{
              fontSize:
                "clamp(2.5rem,5vw,4rem)",
            }}
          >
            Contact Us
          </h1>

          <p
            className="lead mx-auto"
            style={{
              maxWidth: "800px",
            }}
          >
            Have questions,
            suggestions,
            feedback,
            or business inquiries?
            We would love to hear from you.
          </p>

        </div>

      </section>

      {/* CONTACT SECTION */}

      <div className="container py-5">

        <div className="row g-4">

          {/* FORM */}

          <div className="col-lg-7">

            <div className="card border-0 shadow-lg rounded-4 p-4 p-md-5">

              <h2 className="fw-bold mb-4">
                Send a Message
              </h2>

              <form onSubmit={handleSubmit}>

                <div className="mb-4">

                  <label className="form-label fw-semibold">
                    Full Name
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your name"
                    required
                  />

                </div>

                <div className="mb-4">

                  <label className="form-label fw-semibold">
                    Email Address
                  </label>

                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email"
                    required
                  />

                </div>

                <div className="mb-4">

                  <label className="form-label fw-semibold">
                    Message
                  </label>

                  <textarea
                    rows="6"
                    className="form-control"
                    placeholder="Write your message..."
                    required
                  />

                </div>

                <button
                  className="btn btn-primary px-5 py-2"
                  type="submit"
                >
                  Send Message
                </button>

              </form>

              {submitted && (

                <div className="alert alert-success mt-4">

                  Thank you for contacting us.
                  We will respond soon.

                </div>

              )}

            </div>

          </div>

          {/* SIDEBAR */}

          <div className="col-lg-5">

            <div className="card border-0 shadow-lg rounded-4 p-4 mb-4">

              <h3 className="fw-bold mb-4">
                Contact Information
              </h3>

              <div className="mb-4">

                <h5 className="fw-bold">
                  Email
                </h5>

                <p className="text-muted mb-0">
                  emicalculator.official@gmail.com
                </p>

              </div>

              <div className="mb-4">

                <h5 className="fw-bold">
                  Support Hours
                </h5>

                <p className="text-muted mb-0">
                  Monday - Saturday
                  <br />
                  9:00 AM - 6:00 PM
                </p>

              </div>

              <div>

                <h5 className="fw-bold">
                  Platform
                </h5>

                <p className="text-muted mb-0">
                  Free Online Tools Center
                </p>

              </div>

            </div>

            <div className="card border-0 shadow-lg rounded-4 p-4">

              <h4 className="fw-bold mb-3">
                Quick Links
              </h4>

              <div className="d-grid gap-3">

                <a
                  href="/about-us"
                  className="btn btn-outline-primary"
                >
                  About Us
                </a>

                <a
                  href="/privacy-policy"
                  className="btn btn-outline-primary"
                >
                  Privacy Policy
                </a>

                <a
                  href="/terms-conditions"
                  className="btn btn-outline-primary"
                >
                  Terms & Conditions
                </a>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* FAQ */}

      <section className="py-5 bg-light">

        <div className="container">

          <div className="text-center mb-5">

            <h2 className="fw-bold">
              Frequently Asked Questions
            </h2>

          </div>

          <div className="accordion" id="contactFaq">

            <div className="accordion-item">

              <h2 className="accordion-header">

                <button
                  className="accordion-button"
                  data-bs-toggle="collapse"
                  data-bs-target="#cf1"
                >
                  How can I contact support?
                </button>

              </h2>

              <div
                id="cf1"
                className="accordion-collapse collapse show"
              >

                <div className="accordion-body">

                  You can contact us using
                  the form above or by email.

                </div>

              </div>

            </div>

            <div className="accordion-item">

              <h2 className="accordion-header">

                <button
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#cf2"
                >
                  Do you accept feedback?
                </button>

              </h2>

              <div
                id="cf2"
                className="accordion-collapse collapse"
              >

                <div className="accordion-body">

                  Yes, we welcome suggestions
                  and feature requests.

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>

      <Footer />

    </>
  );
}